import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAlarm = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M11.667 5.488c-4.418 0-8 3.552-8 7.934 0 4.381 3.582 7.933 8 7.933s8-3.552 8-7.933c0-4.382-3.582-7.934-8-7.934ZM1 13.422C1 7.579 5.776 2.843 11.667 2.843c5.89 0 10.666 4.736 10.666 10.579C22.333 19.264 17.558 24 11.667 24S1 19.264 1 13.422Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M11.667 8.132c.736 0 1.333.592 1.333 1.323v2.644h1.333c.737 0 1.334.592 1.334 1.323 0 .73-.597 1.322-1.334 1.322h-2.666a1.328 1.328 0 0 1-1.334-1.322V9.455c0-.73.597-1.323 1.334-1.323ZM6.078.743c.433.59.302 1.418-.294 1.847L2.118 5.235a1.34 1.34 0 0 1-1.863-.292A1.315 1.315 0 0 1 .55 3.096L4.216.45a1.34 1.34 0 0 1 1.862.292Zm11.177 0a1.34 1.34 0 0 1 1.863-.292l3.666 2.645c.596.43.727 1.256.294 1.847a1.34 1.34 0 0 1-1.862.292L17.549 2.59a1.315 1.315 0 0 1-.294-1.847Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgAlarm);
export default ForwardRef;
